import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | paid | timeout | error
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setState("error"); return; }
    let timer;
    const poll = async () => {
      if (attempts.current >= 6) { setState("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          await refresh();
          setState("paid");
          setTimeout(() => navigate("/feed"), 1800);
          return;
        }
      } catch { /* keep polling */ }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [refresh, navigate]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="bg-[#0F1420] border border-[#232D42] rounded-2xl p-10 text-center max-w-md w-full" data-testid="payment-success">
        {state === "checking" && <><Loader2 size={40} className="mx-auto text-[#00E5A3] animate-spin mb-4" /><h1 className="font-heading text-xl font-bold text-slate-100">Confirming your payment…</h1><p className="text-sm text-slate-400 mt-2">One moment while we unlock your access.</p></>}
        {state === "paid" && <><CheckCircle2 size={44} className="mx-auto text-[#00E5A3] mb-4" /><h1 className="font-heading text-2xl font-bold text-slate-100">You're in! 🎉</h1><p className="text-sm text-slate-400 mt-2">Your upgrade is live. Taking you to the feed…</p></>}
        {state === "timeout" && <><Loader2 size={40} className="mx-auto text-[#FFB020] mb-4" /><h1 className="font-heading text-xl font-bold text-slate-100">Still processing</h1><p className="text-sm text-slate-400 mt-2">Payment is taking a little longer than usual. Your access will unlock automatically once it clears.</p><Link to="/feed" className="text-[#00E5A3] hover:underline text-sm mt-4 inline-block">Go to feed →</Link></>}
        {state === "error" && <><XCircle size={40} className="mx-auto text-[#FF4D4D] mb-4" /><h1 className="font-heading text-xl font-bold text-slate-100">Something went wrong</h1><Link to="/pro" className="text-[#00E5A3] hover:underline text-sm mt-4 inline-block">Back to plans →</Link></>}
      </div>
    </div>
  );
}
